export default {
  name: "iconBtn",
  props: {
    suffix: {
      // 想用 element 的图标，就传空，ex: suffix=""
      type: String,
      default: "joinmc"
    },
    icon: {
      type: String,
      required: false
    },
    size: {
      type: Number,
      default: 16
    },
    fontWeight: {
      type: [Number, String],
      default: 500
    }
  },
  methods: {
    handleClick(event) {
      this.$emit("click", event);
    }
  }
};